import { render, staticRenderFns } from "./PixSeguro.vue?vue&type=template&id=f04c0d26&scoped=true&"
import script from "./PixSeguro.vue?vue&type=script&lang=js&"
export * from "./PixSeguro.vue?vue&type=script&lang=js&"
import style0 from "./PixSeguro.vue?vue&type=style&index=0&id=f04c0d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04c0d26",
  null
  
)

export default component.exports